import { IonBadge, IonContent, IonPage } from '@ionic/react';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';
import { axius, types } from '../../utils';
import { Loading, Header } from 'components';
import moment from 'moment';

import './_style.scss';

interface Props extends RouteComponentProps, types.StateProps { };
const CouponHistory: React.FC<Props> = props => {

    const { _auth: { user } } = props;

    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getData = () => {
        setLoading(true);
        axius.get(`promotions-orders`, { scan_by: user.id, }).then((res: types.AxiusResponse) => {
            setData(res.status === 200 ? res.data : []);
            setLoading(false);
        });
    }

    return (
        <IonPage id="Coupon">
            <Header {...props} title="Coupon History" />

            <IonContent fullscreen={false}>
                {loading && (<Loading style={{ height: '80vh' }} />)}

                {!loading && data.length === 0 && (
                    <div className="text-center mt-4">No orders found!</div>
                )}

                {!loading && data.map((row: any) => (
                    <div key={row.uuid} className="dividers p-3 mb-2 pointer cards fs-12" style={{ background: '#f6f6f6' }}>
                        <div className="d-flex justify-content-between mb-2">
                            <div className="text-muted small">#{row.id}</div>
                        </div>
                        <div className="small">• {row.items[0].name} {(row.items.length - 1) > 0 && (<span className="fw-500">+{row.items.length - 1} more</span>)}</div>
                        <div className="mt-2 text-muted small"><i className="fa fa-user" /> {row.user.firstName} {row.user.lastName}</div>
                        <div className="mt-2 text-muted small"><i className="fa fa-calendar" /> {moment(row.createdAt).fromNow()}</div>
                        <div className="d-flex mt-2">
                            <IonBadge color={'primary'} className="small fw-400 mr-2 text-capitalize">
                                <small>&nbsp;&nbsp;{row.promotion.name}&nbsp;&nbsp;</small>
                            </IonBadge>
                        </div>
                    </div>
                ))}
            </IonContent>
        </IonPage>
    );
};

export default CouponHistory;
